import { Factory, PackageSearch, Scale, Truck, Heart } from "lucide-react";
import { SectionTag, MaskedLine } from "./Motion";
import Pipeline from "./Pipeline";

const steps = [
  {
    icon: Factory,
    title: "Supplier",
    desc: "Vetted factories and wholesalers across 12 countries, audited before they quote.",
    testid: "sourcing-flow-supplier",
  },
  {
    icon: PackageSearch,
    title: "Sourcing",
    desc: "Product shortlists matched to your audience, price band and margin targets.",
    testid: "sourcing-flow-sourcing",
  },
  {
    icon: Scale,
    title: "Negotiation",
    desc: "Bulk pricing, payment terms and samples — fought for by our ops desk.",
    testid: "sourcing-flow-negotiation",
  },
  {
    icon: Truck,
    title: "Operations",
    desc: "QC, consolidation and logistics tracked end-to-end, in one dashboard.",
    testid: "sourcing-flow-operations",
  },
  {
    icon: Heart,
    title: "Customer",
    desc: "Doorstep delivery with white-glove aftercare that turns buyers into regulars.",
    testid: "sourcing-flow-customer",
  },
];

const chips = ["12 COUNTRIES", "4,200+ SKUS", "98.6% QC PASS"];

export default function Sourcing() {
  return (
    <section id="sourcing" data-testid="sourcing-section" className="relative py-28 sm:py-36">
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-16">
        <SectionTag index="07" label="Smarter Sourcing" testid="sourcing-tag" />
        <div className="flex flex-wrap items-end justify-between gap-8">
          <h2 className="mt-6 max-w-2xl text-4xl font-bold tracking-tight text-neutral-50 sm:text-5xl">
            <MaskedLine>From factory floor</MaskedLine>
            <MaskedLine delay={0.12} innerClassName="font-serif italic font-medium text-gold-grad">
              to front door.
            </MaskedLine>
          </h2>
          <div className="flex flex-wrap gap-3">
            {chips.map((c) => (
              <span
                key={c}
                className="rounded-full border border-gold/25 bg-white/[0.02] px-4 py-2 font-mono text-[10px] tracking-[0.2em] text-goldlight/80"
              >
                {c}
              </span>
            ))}
          </div>
        </div>

        <div className="mt-20">
          <Pipeline steps={steps} lineTestid="sourcing-progress-line" />
        </div>
      </div>
    </section>
  );
}
